<template>
  <form @submit.prevent="submitForm" novalidate>
    <div class="row">
      <div class="col-12">
        <SelectVue
            v-model="formData.coachingId"
            :options="coachingDropdown"
            :required="true"
            label="Maßnahmenn"
            placeholder="Wählen Sie Maßnahmen"
            :validation="v$.coachingId"
            :messages="v$.coachingId.required.$message"/>
      </div>
    </div>

    <div class="form-buttons-w text-center">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup lang="ts">
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, defineEmits, defineProps, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import useVuelidate from '@vuelidate/core';
import {requiredRule} from "@/shared/validators/validationRules";
import unemployedPrivateCoachingService from "@/api/Unemployed/PrivateCoaching";
import SelectVue from "@/components/SelectVue.vue";
import SaveButton from "@/components/button/SaveButton.vue";
// @ts-ignore
import {getPrivateCoachingByUnemployedDropdown} from '@/shared/dropdowns';

const {t} = useI18n();
const route = useRoute();
const unemployedId = +(route.params.unemployedId || route.params.id);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);
const isSubmitting = ref(false);
const isLoaded = ref(false);
const coachingDropdown = ref([])

const props = defineProps({
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  unemployedId: {
    type: String,
    required: true,
  },
  documentGroupUuid: {
    type: String,
    required: false,
    default: '',
  },
  selectedCoachingId: {
    type: Number,
    required: false,
    default: null,
  }
});

const formData = ref<any>({
  documentsGroupId: "",
  coachingId: "",
});

watch(
    () => props.selectedCoachingId,
    (coachingId) => {
      if (coachingId) {
        formData.value.coachingId = coachingId;
      }
    },
    { immediate: true }
);

const rules = computed(() => {
  return {coachingId: requiredRule(t)};
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {

    await unemployedPrivateCoachingService.assignedCoachingToDigitalDocuments(
        props.documentGroupUuid,
        formData.value.coachingId
    );

    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  CloseToast()
  await Promise.all([
    getPrivateCoachingByUnemployedDropdown(coachingDropdown,props.unemployedId)
  ])

  isLoaded.value = true;
});
</script>

<style scoped>
</style>

